import { useState, useEffect, useRef } from "react"
import { TabsProps, TabsContext } from "./types"

export interface UseTabsResult extends TabsContext, TabsProps {}

export function useTabs(props: TabsProps): UseTabsResult {
  const {
    defaultIndex,
    index,
    isLazy,
    showPreviousNextButtons,
    onTabChange,
    ...htmlProps
  } = props

  const [focusedIndex, setFocusedIndex] = useState(defaultIndex ?? 0)
  const [selectedIndex, setSelectedIndex] = useState(index ?? defaultIndex ?? 0)
  const tabRefs = useRef(new Map<number, HTMLElement>())
  const id = props.id ?? props.nativeID

  const setTabRef = (index: number) => (ref: HTMLElement | null) => {
    if (ref) {
      tabRefs.current.set(index, ref)
    }
  }

  useEffect(() => {
    if (index !== undefined) {
      setFocusedIndex(index)
    }
  }, [index])

  useEffect(() => {
    onTabChange?.(selectedIndex)
  }, [selectedIndex])

  return {
    ...htmlProps,
    id,
    isLazy,
    showPreviousNextButtons:
      showPreviousNextButtons && typeof window !== "undefined", // do not show buttons on server side
    selectedIndex,
    focusedIndex,
    setSelectedIndex,
    setFocusedIndex,
    tabRefs,
    setTabRef,
  }
}
